import React, { useState, useEffect } from 'react'
import moment from 'moment';
import { getemiDataAuditByData } from '../../AdminActionCreator.component';
import Pagination from '@mui/material/Pagination';
import Loader from '../../../../presentationals/Loader/Loader.component'

const itemsPerPage = 10;
const cardStyle = {
    boxShadow: "rgb(204, 204, 204) 5px 5px 10px",
    borderRadius: '8px',
    margin: '30px auto 0px',
    background: 'rgb(255, 255, 255)', padding: '10px 13px',
    // minHeight:'122px'
};

const Listtypedata = [
    {
        name: "EMI List",
        value: "EMI_LIST"
    },
    {
        name: "Overdue List",
        value: "OVERDUE_LIST"
    },
    {
        name: "Payment List",
        value: "PAYMENT_LIST"
    },
    {
        name: "Not In both List",
        value: "NOT_IN_BOTH_LIST"
    },
    {
        name: "Found In both List",
        value: "FOUND_IN_BOTH_LIST"
    },
    {
        name: "In Payment Not in EMI List",
        value: "IN_PAYMENTS_NOT_IN_EMI"
    },
    {
        name: "In Overdue Not in EMI List",
        value: "IN_OVERDUE_NOT_IN_EMI"
    },
]

const differenceDate = () => {
    let d = new Date()
    let todaysDate = d.getDate();
    return todaysDate - 1
}

const InitalDate = (type) => {
    const FirstDay = moment().subtract(differenceDate(), 'days');
    if (type === 'fromDate') {
        const fromdate = FirstDay.format('YYYY-MM-DD');
        return fromdate
    } else if (type === 'toDate') {
        const todate = moment(new Date).format('YYYY-MM-DD')
        return todate
    }
}

export default function Audit({ userDetailHandler }) {
    const [loader, setLoader] = useState(false)
    const [currentPage, setcurrentPage] = useState(1)
    const [apiData, setApidata] = useState({})
    const [paginatedData, setpaginatedData] = useState([])
    const [payload, setPayload] = useState({
        startDate: InitalDate("fromDate"),
        endDate: InitalDate("toDate"),
        returnListType: Listtypedata[0]?.value
    })

    const handleType = (e, type) => {

        setPayload((prev) => ({
            ...prev,
            [type]: e.target.value
        }))

    }

    const handleApply = () => {
        getemiDataAuditByDataFn(payload)
    }

    const handlePageChange = (e, value) => {
        setcurrentPage(value)
        handleFilteration(value, apiData?.objectList)
    }

    useEffect(() => {
        getemiDataAuditByDataFn(payload)
    }, [])

    const getemiDataAuditByDataFn = (data) => {
        const obj = {
            ...data,
            startDate: moment(data?.startDate).format("DD-MM-YYYY"),
            endDate: moment(data?.endDate).format("DD-MM-YYYY"),
        }
        setLoader(true)
        getemiDataAuditByData(obj, callback => {
            setLoader(false)
            setcurrentPage(1)
            if (callback?.status == 200 && callback?.message == "success") {
                setApidata(callback?.data)
                handleFilteration(1, callback?.data?.objectList)
            } else {
                setApidata({})
            }
        })
    }

    const handleFilteration = (currentPage, data) => {
        if (data?.length > 0) {
            const indexOfLastItem = currentPage * itemsPerPage;
            const indexOfFirstItem = indexOfLastItem - itemsPerPage;
            const currentItems = data && data?.length > 0 ? data?.slice(indexOfFirstItem, indexOfLastItem) : [];
            setpaginatedData(currentItems)
        } else {
            setpaginatedData([])
        }
    }


    return (
        <>
            <div className="container-fluid">
                {
                    loader ?
                        <Loader />
                        : ''}
                <div className="row">
                    <div className="col-sm-2 col-xs-4">
                        <label>Start Date </label>
                        <input
                            id="customDateInput"
                            type="date"
                            max={payload.endDate}
                            className="form-control"
                            value={payload.startDate}
                            onChange={(e) => handleType(e, "startDate")}
                        />
                    </div>
                    <div className="col-sm-2 col-xs-12">
                        <label>End Date: </label>
                        <input
                            id="customDateInput"
                            type="date"
                            min={payload.startDate}
                            className="form-control"
                            value={payload.endDate}
                            onChange={(e) => handleType(e, "endDate")}
                        />
                    </div>
                    <div className="col-sm-2 col-xs-12">
                        <label>List type: </label>
                        <select className='form-control' value={payload?.returnListType} onChange={(e) => handleType(e, "returnListType")}>
                            {
                                Listtypedata && Listtypedata?.map((value, id) => {
                                    return (
                                        <option value={value?.value}>{value?.name}</option>
                                    )
                                })
                            }
                        </select>
                    </div>
                    <div className="col-sm-2 col-xs-12">
                        <button onClick={() => handleApply()} className='btn btn-primary' style={{ padding: '10px', marginTop: '22px' }}>Apply Filter</button>
                    </div>
                </div>

                <div className="row" style={{ marginTop: '20px' }}>
                    <div className="col-lg-3 col-sm-6 col-xs-12">
                        <div style={{ ...cardStyle, borderLeft: '5px solid #41bafc' }}>
                            <div>
                                <h2>{apiData?.totalEmi ?? 0}</h2>
                                <h5>Total EMI</h5>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-sm-6 col-xs-12">
                        <div style={{ ...cardStyle, borderLeft: '5px solid #fcae41' }}>
                            <div>
                                <h2>{apiData?.numberOfPaidEmi ?? 0}</h2>
                                <h5>No Of Paid EMI's</h5>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-xs-12">
                        <div style={{ ...cardStyle, borderLeft: '5px solid #41bafc' }}>
                            <div>
                                <h2>{apiData?.numberOfOverdue ?? 0}</h2>
                                <h5>No Of Overdue</h5>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-xs-12">
                        <div style={{ ...cardStyle, borderLeft: '5px solid #fcae41' }}>
                            <div>
                                <h2>{apiData?.numberOfEmiInBoth ?? 0}</h2>
                                <h5>No Of EMI In Both</h5>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-xs-12">
                        <div style={{ ...cardStyle, borderLeft: '5px solid #41bafc' }}>
                            <div>
                                <h2>{apiData?.totalEmiAmount ?? 0}</h2>
                                <h5>Total EMI Amount</h5>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 col-sm-6 col-xs-12">
                        <div style={{ ...cardStyle, borderLeft: '5px solid #fcae41' }}>
                            <div>
                                <h2>{apiData?.totalPaidAmount ?? 0}</h2>
                                <h5>Total Paid Amount</h5>
                            </div>
                        </div>
                    </div>


                    <div className="col-lg-3 col-sm-6 col-xs-12">
                        <div style={{ ...cardStyle, borderLeft: '5px solid #41bafc' }}>
                            <div>
                                <h2>{apiData?.totalOverdueAmount ?? 0}</h2>
                                <h5>Total Overdue Amount</h5>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-sm-6 col-xs-12">
                        <div style={{ ...cardStyle, borderLeft: '5px solid #fcae41' }}>
                            <div>
                                <h2>{apiData?.numberOfEmiNotInOverdueOrPayment ?? 0}</h2>
                                <h5>No Of EMI not in Overdue or Payment</h5>
                            </div>
                        </div>
                    </div>

                </div>

                <div className="row">
                    <div className="col-xs-12">
                        {
                            paginatedData && paginatedData?.length > 0 ?

                                <div className="phocket-table-new" style={{ boxShadow: 'rgb(204, 204, 204) 5px 5px 10px', padding: '10px', borderRadius: '15px', marginTop: '40px' }}>
                                    <div style={{ overflowX: 'auto' }}>
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th className='text-center'>Details</th>
                                                    <th className='text-center'>Application Id</th>
                                                    <th className='text-center'>Name</th>
                                                    <th className='text-center'>EMI Amount</th>
                                                    <th className='text-center'>Due Date</th>
                                                    <th className='text-center'>EMI Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    paginatedData?.map((value, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td className='text-center'>
                                                                    <i className='fa fa-info' style={{ cursor: 'pointer' }} onClick={() => userDetailHandler(value)}></i>
                                                                </td>
                                                                <td className='text-center'>{value?.applicationId}</td>
                                                                <td className='text-center'>{value?.name}</td>
                                                                <td className='text-center'>{value?.emiAmount}</td>
                                                                <td className='text-center'>{value?.dueDate}</td>
                                                                <td className='text-center'>{value?.emiStatus}</td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <div style={{ marginTop: '15px' }}>
                                        <Pagination
                                            count={Math.ceil(apiData?.objectList?.length / itemsPerPage)}
                                            page={currentPage}
                                            onChange={handlePageChange}
                                            color="primary" style={{ display: 'flex', justifyContent: 'end' }}
                                        />
                                    </div>
                                </div>
                                : ''}
                    </div>
                </div>
            </div>

        </>
    )
}
